import React, { Component } from 'react';
import './SearchBar.scss'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSideBar, updateCurrentTabStatus, highlightSearchedResult, updateCurrentGenericTabStatus } from '../../Redux/Actions/uiActions';
import history from '../../Routers/history';
import ImgTag from '../../Elements/Atoms/ImgTag';
import searchIcon from '../../../assets/icons/ic_search_blue.png';
import clearIcon from '../../../assets/icons/ic_close_light_grey.png';

class SearchBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: '',
            showListState: false,
            maxMatch: 50
        }

        this.InputRef = React.createRef();
        // this.listNode = React.createRef();
        // this.listEmpty = React.createRef();
        this.timeout = '';
        this.searchedData = [];
        this.searchItemCount = 0;
        this.isGeneric = false;
    }

    UNSAFE_componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    componentDidMount() {
        const firstParam = window.location.pathname.split('/')[1];
        const inputField = this.InputRef.current;
        if(firstParam === 'genericconfig') {
            this.isGeneric = true;
        } else {
            this.isGeneric = false;
        }
        if(this.props.highlightSearchedData && this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length) {
            this.InputRef.current.value = this.props.highlightSearchedData.title;
            this.setState({ inputValue: this.props.highlightSearchedData.title });
        }
        window.addEventListener("keydown",function (e) {
            if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
                inputField.focus();
                e.preventDefault();
            }
        })
    }

    handleClick = (e) => {
        if(this.listNode && this.listNode.contains(e.target)) {
            let parentId = parseInt(e.target.parentElement.getAttribute('data-id'));
            if(e.target.classList.contains('search-bar-searched-list-item')) {
                parentId = parseInt(e.target.getAttribute('data-id'));
            }

            let tabToBeSelected = '';
            if(this.searchedData[parentId]['parent'][0] === 'SETTINGS' || this.searchedData[parentId]['parent'][0] === 'POST_OPTIONS' || this.searchedData[parentId]['parent'][0] === 'OPTIONS') {
                tabToBeSelected = 'settings';
            } else if(this.searchedData[parentId]['parent'][0] === 'UI_OPTIONS') {
                // console.log(this.searchedData[parentId]['parent'][1]);
                let tempTab = this.searchedData[parentId]['parent'][1];
                if(tempTab === 'CHATBOT') {
                    tabToBeSelected = 'chatbot';
                } else if(tempTab === 'USER_SIDE_SETTINGS' || tempTab === 'AGENT_SIDE_SETTINGS') {
                    tabToBeSelected = 'uisettings';
                } else if(tempTab === 'CARDS') {
                    tabToBeSelected = 'cards';
                } else if(tempTab === 'MISC_TEXT') {
                    tabToBeSelected = 'messagesettings';
                } else if(tempTab === 'MISC_IMAGES') {
                    tabToBeSelected = 'images';
                } else if(tempTab === 'FRAMEWORKS') {
                    tabToBeSelected = 'framework';
                } else if(tempTab === 'CUSTOM_JS') {
                    tabToBeSelected = 'customjs';
                } else if(tempTab === 'CUSTOM_CSS') {
                    tabToBeSelected = 'customcss';
                } else {
                    tabToBeSelected = 'chatbot';
                }
            } else {
                tabToBeSelected = 'chatbot';
            }

            let tempObj = {}, tempParrentArr = [];

            if(this.searchedData[parentId]['parent'][0] === 'CHATBOT' || this.searchedData[parentId]['parent'][0] === 'SETTINGS' || this.searchedData[parentId]['parent'][0] === 'POST_OPTIONS' || this.searchedData[parentId]['parent'][0] === 'OPTIONS') {
                tempObj = this.searchedData[parentId];
                tempParrentArr = this.searchedData[parentId]['parent'];
                if(Object.keys(this.searchedData[parentId])[0] === 'VALUE') {
                } else {
                    tempParrentArr.push(Object.keys(this.searchedData[parentId])[0]);
                }
                tempObj['parent'] = tempParrentArr;
            } else {
                tempObj = this.searchedData[parentId];
                tempParrentArr = this.searchedData[parentId]['parent'];
                tempParrentArr.shift();
                if(Object.keys(this.searchedData[parentId])[0] === 'VALUE') {
                } else {
                    tempParrentArr.push(Object.keys(this.searchedData[parentId])[0]);
                }
                // console.log(tempParrentArr, Object.keys(this.searchedData[parentId]));
                tempObj['parent'] = tempParrentArr;
            }

            let keys = Object.keys(this.searchedData[parentId]);
            let itemTitle = this.searchedData[parentId][keys[0]];
            if(typeof this.searchedData[parentId][keys[0]] === 'object') {
                // itemTitle = keys[0] + ' > Object';
                itemTitle = keys[0];
            }
            if(this.searchedData[parentId][keys[0]] === 'true' || this.searchedData[parentId][keys[0]] === 'false') {
                this.searchedData[parentId]['parent'].pop();
                itemTitle = this.searchedData[parentId]['parent'][this.searchedData[parentId]['parent'].length - 1];
            }

            // console.log('------------------------------',itemTitle);
            this.InputRef.current.value = itemTitle;
            this.setState({ inputValue: itemTitle });
            tempObj.title = itemTitle;

            this.props.highlightSearchedResult(tempObj);
            setTimeout(() => {
                this.props.highlightSearchedResult({});
            }, 15000);

            if(this.isGeneric) {
                this.props.updateCurrentGenericTabStatus(tabToBeSelected);
                history.push(`/genericconfig/${tabToBeSelected}`);
            } else {
                this.props.updateCurrentTabStatus(tabToBeSelected);
                history.push(`/${this.props.selectedBotID}/${tabToBeSelected}`);
            }
            // console.log(parentId, 'check', this.searchedData[parentId]);

            this.setState({ showListState: false });
            return;
        }

        if(this.listEmpty && this.listEmpty.contains(e.target)) {
            return;
        }
        this.setState({ showListState: false });
    }

    searchForInput = (inputVal) => {
        this.setState({ inputValue: inputVal,showListState: false });
        if(inputVal.length === 0) {
            this.props.highlightSearchedResult({});
        }
        inputVal = inputVal.trim();
        // console.log('this', this.props.editableBotData)
        const dataToBeSearchedFrom = this.isGeneric ? this.props.genericBotData : this.props.editableBotData;
        if(inputVal.length > 1) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.searchedData = [];
                this.searchItemCount = 0;
                this.runThis(dataToBeSearchedFrom, inputVal)
                // console.log(this.searchedData);
                this.setState({showListState: true});
            }, 300);
        }
    }

    searchInObject = (parent, self, toBeSearch) => {
        if(self === null || self === undefined) return;
        let keys = Object.keys(self)
        for (let i = 0 ; i < keys.length ; i++) {
            if(this.searchItemCount >= this.state.maxMatch) return
            let selfKeys = self[keys[i]];
            let tempkeys = keys[i];
            let tempMatchKeys = tempkeys.replace(/_/g,' ').toLowerCase();
            let tempMatchToBeSearched = toBeSearch.replace(/_/g,' ').toLowerCase();
            let tempMatchSelfKeys;
            let permittedParentArr = ['POST_OPTIONS', 'OPTIONS', 'SETTINGS', 'UI_OPTIONS', 'CHATBOT']
            if(parent && parent.length && permittedParentArr.indexOf(parent[0]) > -1) {
                if ((typeof selfKeys == "string" || typeof selfKeys == "number" || typeof selfKeys == "boolean" || Array.isArray(selfKeys)) && (tempkeys !== 'ELEM_TYPE' && tempkeys !== 'ELEM_DESC')) {
                    selfKeys = String(selfKeys);
                    tempMatchSelfKeys = selfKeys.replace(/_/g,' ').toLowerCase();
                    if (tempMatchKeys.indexOf(tempMatchToBeSearched) > -1) {
                        let obj = {};
                        obj[tempkeys] = selfKeys;
                        obj.parent = parent;
                        this.searchedData.push(obj);
                        this.searchItemCount++;
                    }
                    if (tempMatchSelfKeys.indexOf(tempMatchToBeSearched) > -1) {
                        let obj = {};
                        obj[tempkeys] = selfKeys;
                        obj.parent = parent;
                        this.searchedData.push(obj);
                        this.searchItemCount++;
                    }
                } else if (typeof selfKeys == "object" && tempMatchKeys.indexOf(tempMatchToBeSearched) > -1) {
                    let obj = {};
                    obj[tempkeys] = selfKeys;
                    obj.parent = parent;
                    this.searchedData.push(obj);
                    this.searchItemCount++;
                } else {
                    this.searchInObject([...parent, tempkeys], selfKeys, toBeSearch)
                }
            } else if(parent.length === 0){
                this.searchInObject([...parent, tempkeys], selfKeys, toBeSearch);
            }
        }
    }

    runThis = async (data, toBeSearch) => {
        return await this.searchInObject([], data, toBeSearch);
    }

    addSearchedList = () => {
        if(!this.state.inputValue.trim().length) {
            this.searchedData = [];
            return null;
        }
        if(this.searchedData.length) {
            return(
                <div className = 'search-bar-searched-list' ref = {listNode => this.listNode = listNode}>
                    <ul className = 'search-bar-searched-list-container'>
                        {
                            this.searchedData.map((elem, key) => {
                                let keys = Object.keys(elem);
                                let itemTitle = keys[0] + ' > ' + elem[keys[0]];
                                if(typeof elem[keys[0]] === 'object') {
                                    // itemTitle = keys[0] + ' > Object';
                                    itemTitle = keys[0];
                                }
                                let itemPath = elem[keys[1]].toString();
                                    itemPath = itemPath.replace(/,/g,' > ');
                                return (
                                    <li className = 'search-bar-searched-list-item' title = {itemTitle} key = {key} data-id = {key}>
                                        <div className = 'search-bar-searched-list-item-title'>{itemTitle}</div>
                                        <i className = 'search-bar-searched-list-item-path'>{itemPath}</i>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            );
        } else {
            return(<div className = 'search-bar-searched-list empty-state' ref = {listEmpty => this.listEmpty = listEmpty}>No match found</div>);
        }
    }

    addClearButton = () => {
        return (
            <span className = 'search-bar-input-clear' onClick = {
                () => {
                    this.setState({inputValue: '',showListState: false});
                    this.InputRef.current.value = '';
                    this.props.highlightSearchedResult({});
                }
            }>
                <ImgTag
                    alt = 'search'
                    className = 'image'
                    src = {clearIcon}
                />
            </span>
        );
    }

    render() {
        if(!this.state.inputValue) {
            // this.props.highlightSearchedResult({});
        }
        return (
            <div className = 'search-bar-container'>
                <input
                    className = 'search-bar-input'
                    id = 'search-bar-input-global'
                    type = 'text'
                    placeholder = 'Search'
                    defaultValue = { this.state.inputValue }
                    ref = {this.InputRef}
                    autoComplete = 'off'
                    onChange = {
                        (e) => {
                            this.searchForInput(e.target.value);
                        }
                    }
                    onKeyPress = {
                        (e) => {
                            if(e.which === 13) {
                                this.searchForInput(this.state.inputValue);
                            }
                        }
                    }
                />
                <label htmlFor = 'search-bar-input-globals' className = 'search-bar-input-label' onClick = {
                    () => {
                        this.searchForInput(this.state.inputValue);
                    }
                }>
                    <ImgTag
                        alt = 'search'
                        className = 'image'
                        src = {searchIcon}
                    />
                </label>
                { this.state.inputValue.length ? this.addClearButton() : null }
                { this.state.showListState ? this.addSearchedList() : null }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        SIDE_MENU: state.UiReducer && state.UiReducer.SIDE_MENU ? state.UiReducer.SIDE_MENU : false,
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID && (state.UiReducer.selectedBotID !== '') ? state.UiReducer.selectedBotID : false,
        selectedBot: state.UiReducer && state.UiReducer.selectedBot && (state.UiReducer.selectedBot !== 'Select Bot') ? state.UiReducer.selectedBot : false,
        isLoggedIn: state.UiReducer && state.UiReducer.isLoggedIn ? state.UiReducer.isLoggedIn : false,
        currentGenericActiveTab: state.UiReducer && state.UiReducer.currentGenericActiveTab ? state.UiReducer.currentGenericActiveTab : '',
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {},
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {}
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        toggleSideBar,
        updateCurrentTabStatus,
        highlightSearchedResult,
        updateCurrentGenericTabStatus
    },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchBar);